// 


import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useId } from 'react';
import styles from './status.module.css';
import SecondaryTooltip from '../secondaryToolTip/secondaryToolTip';
import { USER_TYPE } from '../../utils/constants/userConstants';

const Status = ({ isQuickSearch,statuses, onStatusChange, checkedStatuses: controlledStatuses, infoImage, currentUserType, onResetfilter,outline,label="Status" }) => {
  const [internalStatuses, setInternalStatuses] = useState(
    statuses.reduce((acc, status) => ({ ...acc, [status.id]: true }), {})
  );
  const checkedStatuses = controlledStatuses || internalStatuses;
// useEffect(() => {
//   if (isQuickSearch) {
//     const initialStatuses = statuses.reduce((acc, status) => ({
//       ...acc, [status.id]: true 
//     }), {});
//     setCheckedStatuses(initialStatuses);
//   }
// }, [isQuickSearch]);

  useEffect(() => {
      onStatusChange(checkedStatuses);
  }, []);

  const handleCheckboxChange = (statusId) => {
    const updateFn = (prev) => {
      const newCheckedStatuses = { ...prev, [statusId]: !prev[statusId] };

      if (statusId === 'all') {
        const allChecked = newCheckedStatuses[statusId];
        statuses.forEach(status => {
          newCheckedStatuses[status.id] = allChecked;
        });
      } else {
        if (!newCheckedStatuses[statusId]) {
          newCheckedStatuses.all = false;
        } else {
          const allSpecificStatusesChecked = statuses.every(status => status.id === 'all' || newCheckedStatuses[status.id]);
          newCheckedStatuses.all = allSpecificStatusesChecked;
        }
      }
      if (onResetfilter) {
        onResetfilter();
      }
      return newCheckedStatuses;
    };
    const updated = updateFn(checkedStatuses);
    if (controlledStatuses) {
      onStatusChange(updated);
    } else {
      setInternalStatuses(updated);
    }
  };

  const CheckBox = ({ name, value, label, checked, onChange,color,infoMessage,outline }) => {
    // console.log("outline",outline)
    const id = useId();
    return (
      <div className={styles.radioField}>
        <input
          id={id}
          className={`${styles.radioInput}`}
          type="checkbox"
          name={name}
          value={value}
          checked={checked}
          onChange={onChange}
          style={{ accentColor: color, ...(checked&&{outline:`1px solid ${outline}`, outlineStyle:'auto'}) }}
        />
        <label htmlFor={id} className={styles.radioLabel}>
          {label}
        </label>
        {infoImage && infoMessage && currentUserType===USER_TYPE.INTERNAL && (
        <SecondaryTooltip text={infoMessage} positions={['bottom', 'right']}>
          <img src={infoImage} alt="Info" className={styles.infoImage} />
        </SecondaryTooltip>
        )}
      </div>
    );
  };

  return (
    <div className={styles.statusContainer}>
      <div className={styles.labeltext}>{label}:</div>
      {statuses.map((status) => (
        <CheckBox
          key={status.id}
          name="statuses"
          className={styles.radioInput}
          value={status.id}
          label={`${status.label} (${status.count})`}
          checked={checkedStatuses[status.id]}
          onChange={() => handleCheckboxChange(status.id)}
          color={status.color}
          outline={status.outline}
          infoMessage={status.infoMessage}
        />
      ))}
    </div>
  );
};

Status.propTypes = {
  statuses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      count: PropTypes.number.isRequired,
    })
  ).isRequired,
  onStatusChange: PropTypes.func.isRequired,
  // checkedStatuses: PropTypes.object,
  infoImage: PropTypes.string,
};

export default Status;